import { Controller } from "@hotwired/stimulus"

export default class RebuildMonitorController extends Controller {
  static targets = [
    "statusBadge", "progressBar", "progressText", "currentStep",
    "elapsedText", "geographiesCount", "etaText", "refreshHint"
  ]
  static values = { url: String, active: Boolean }

  connect() {
    if (this.activeValue) {
      this.poll()
    }
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer)
  }

  poll() {
    fetch(this.urlValue, { headers: { "Accept": "application/json" } })
      .then(r => r.json())
      .then(data => this.update(data))
      .catch(() => {})
      .finally(() => {
        if (this.activeValue) {
          this._timer = setTimeout(() => this.poll(), 3000)
        }
      })
  }

  update(data) {
    if (this.hasStatusBadgeTarget) {
      this.statusBadgeTarget.textContent = this.capitalize(data.status)
      this.statusBadgeTarget.className = `status-badge status-${data.status}`
    }

    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${data.progress_percentage}%`
    }

    if (this.hasProgressTextTarget) {
      this.progressTextTarget.textContent =
        `${data.processed_imports} / ${data.total_imports} (${data.progress_percentage}%)`
    }

    if (this.hasCurrentStepTarget) {
      this.currentStepTarget.textContent = data.current_step || ""
    }

    if (this.hasElapsedTextTarget && data.elapsed_seconds !== null) {
      this.elapsedTextTarget.textContent = this.formatDuration(data.elapsed_seconds)
    }

    if (this.hasGeographiesCountTarget) {
      this.geographiesCountTarget.textContent = this.formatNumber(data.geographies_created)
    }

    if (this.hasEtaTextTarget) {
      this.etaTextTarget.textContent = data.eta_display || "Calculating..."
    }

    if (data.status === "completed" || data.status === "failed" || data.status === "cancelled") {
      this.activeValue = false
      if (this.hasRefreshHintTarget) {
        const messages = {
          completed: "Geography rebuild completed successfully.",
          failed: "Geography rebuild failed. Check the error log below.",
          cancelled: "Geography rebuild was cancelled."
        }
        this.refreshHintTarget.textContent = messages[data.status]
      }
      window.location.reload()
    }
  }

  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  formatNumber(n) {
    if (n === null || n === undefined) return "0"
    return Number(n).toLocaleString()
  }

  formatDuration(totalSeconds) {
    if (totalSeconds === null) return "--"
    const h = Math.floor(totalSeconds / 3600)
    const m = Math.floor((totalSeconds % 3600) / 60)
    const s = Math.floor(totalSeconds % 60)
    if (h > 0) return `${h}h ${m}m ${s}s`
    if (m > 0) return `${m}m ${s}s`
    return `${s}s`
  }
}
